import {
    AccountBoxOutlined,
    // EmojiEventsOutlined,
    InfoOutlined,
    PersonOutlineOutlined,
    WatchLaterOutlined,
} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Skeleton } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';

import arrowImg from '../../../assets/arrow.png';
import deliverImg from '../../../assets/delivery-icon.svg';
import locationImg from '../../../assets/locationicon.svg';
import orderImg from '../../../assets/ordericon.svg';
import { getOrder } from '../api/CRUD/getOrder';
import { getUser } from '../api/getUser';
import { handleDateFormat, handleDateTimeFormat, handleOnError } from '@/utils/commonHelperFunc';
import { getLoyaltyPoints } from '@/features/users/api/getLoyaltyPoints';
import { User } from '@/features/users';
import { Button } from '@/components/Elements';
import { axios } from '@/lib/axios';
import { Confirm } from '@/components/Elements/Dialog/Confirm';

const EditOrder = ({ ordersQuery, orderData, closeDialog, selectedUserAction }: any) => {
    const [order, setOrder] = useState<any | null>(null);
    const [user, setUser] = useState<User | null>(null);
    const [loyaltyData, setLoyaltyData] = useState<any | null>(null);
    const [confirmMsg, setConfirmMsg] = useState<any | null>(null);
    const [confirmMsgRefund, setConfirmMsgRefund] = useState<any | null>(null);
    const getCorpUsersFunc = async () => {
        getOrder(orderData.id).then((query) => {
            setOrder(query);
            if (query?.user?.id != null) {
                getUser(query.user.id).then((res) => setUser(res));
            }
        });

        getLoyaltyPoints(orderData?.order_user_id).then((res) => {
            setLoyaltyData(res);
        });
    };

    const updateOrderStatus = async (status: any) => {
        const { success, message }: any = await axios.post(`v1/pos/update-order-status`, status);
        getCorpUsersFunc();
        ordersQuery.refetch();
        return { success, message };
    };
    const updateOrderRefund = async (status: any) => {
        const { success, message }: any = await axios.get(
            `v1/admin/orders/refund?id=${status.order_id}&amount=${status.order_amount}`
        );
        getCorpUsersFunc();
        ordersQuery.refetch();
        return { success, message };
    };

    useEffect(() => {
        getCorpUsersFunc();
    }, [orderData?.id]);
    const delivery_status_list = [
        'new',
        'received',
        'packing',
        'assigned',
        'dispatched',
        'delivered',
        'completed',
    ];
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const pickup_status_list = ['new', 'received', 'packing', 'completed'];
    const order_status_list =
        orderData.order_type == 'Pickup'
            ? pickup_status_list
            : orderData.order_type == 'In-Store'
            ? pickup_status_list
            : delivery_status_list;

    const getDollarPrice = (priceInCents: any) => {
        if (priceInCents == 0) {
            return priceInCents;
        } else if (priceInCents == '-') {
            return '0.00';
        } else {
            return Math.abs(priceInCents / 100).toFixed(2);
        }
    };

    return (
        <>
            {confirmMsg ? (
                <Confirm
                    btnTitle={'Cancel Order'}
                    onClose={() => setConfirmMsg(null)}
                    onSuccess={() => {
                        updateOrderStatus({
                            order_id: order?.id,
                            user_id: order?.user?.id,
                            order_status: 'cancelled',
                        });
                        setConfirmMsg(null);
                        closeDialog();
                    }}
                />
            ) : null}
            {confirmMsgRefund ? (
                <Confirm
                    btnTitle={'Refund Order'}
                    onClose={() => setConfirmMsgRefund(null)}
                    onSuccess={() => {
                        const amount = localStorage.getItem('amount');
                        updateOrderRefund({
                            order_id: order?.id,
                            order_amount: amount,
                        });
                        setConfirmMsgRefund(null);
                        closeDialog();
                    }}
                    orderPrice={order?.order_total}
                />
            ) : null}
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title flex" id="changeStatusModalLabel">
                            Order #{order ? order?.id : <Skeleton component={'span'} width={50} />}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => closeDialog()}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="info-header location-edit pt-0 mb-0">
                            <div className="left-info">
                                <p className="order-flow flex ">
                                    {order_status_list.map((status, index) => (
                                        <div key={index} className="flex align-items-center">
                                            <span
                                                onClick={() => {
                                                    updateOrderStatus({
                                                        order_id: order?.id,
                                                        user_id: order?.user?.id,
                                                        order_status: status,
                                                    });
                                                }}
                                                className={`new-order order order_status-${
                                                    status === order?.status[0]?.order_status &&
                                                    status
                                                } capitalize btn`}
                                            >
                                                {status}
                                            </span>
                                            {order_status_list.length !== index + 1 ? (
                                                <span>
                                                    <img
                                                        className="arrow-img"
                                                        src={arrowImg}
                                                        width="20px"
                                                        height="7px"
                                                        alt="arrowImg"
                                                    />
                                                </span>
                                            ) : null}
                                        </div>
                                    ))}
                                </p>
                            </div>
                            <div className="right-info">
                                <div
                                    style={{
                                        display: 'flex',
                                    }}
                                >
                                    <div
                                        style={{
                                            display:
                                                order?.status[0]?.order_status == 'refunded' ||
                                                order?.status[0]?.order_status == 'cancelled'
                                                    ? 'none'
                                                    : 'block',
                                        }}
                                        className="ml-1"
                                    >
                                        <Button
                                            //onClick={handleStatusChange}
                                            onClick={() => setConfirmMsgRefund('Refund Order')}
                                            variant="secondary"
                                            style={{
                                                width: 'fit-content',
                                                padding: '1px 1px',
                                                fontSize: '13px',
                                            }}
                                        >
                                            Refund Order
                                        </Button>
                                    </div>

                                    <div
                                        style={{
                                            display:
                                                order?.status[0]?.order_status == 'refunded' ||
                                                order?.status[0]?.order_status == 'cancelled' ||
                                                order?.status[0]?.order_status == 'completed'
                                                    ? 'none'
                                                    : 'block',
                                        }}
                                        className="ml-1"
                                    >
                                        <Button
                                            variant="secondary"
                                            style={{
                                                width: 'fit-content',
                                                padding: '1px 1px',
                                                fontSize: '13px',
                                            }}
                                            onClick={() => setConfirmMsg('Cancel Order')}
                                        >
                                            Cancel Order
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {order ? (
                            <div className="row new-order1" style={{ marginTop: '10px' }}>
                                <div className="col-12 col-md-8 new-order-leftcol">
                                    {/* <div className="location-edit mb-0">
                                        <div className="">
                                            <p style={{ marginRight: '20px',marginTop: '10px' }} className="flex">
                                                <img src={locationImg} />{' '}
                                                <strong
                                                    style={{ fontWeight: '600', fontSize: '16px',marginRight: '20px' }}
                                                >
                                                    {order?.order_location?.location_name}
                                                </strong>
                                            </p>
                                            <p className="flex" style={{ marginRight: '20px',marginTop: '10px' }}>
                                                <img src={deliverImg} />{' '}
                                                <strong style={{ fontWeight: '400' }}>
                                                    {order?.order_type?.subcategory}
                                                </strong>
                                            </p>
                                        </div>
                                        <div className="">
                                            <p className="flex" style={{ marginRight: '20px',marginTop: '10px' }}>
                                                <WatchLaterOutlined
                                                    style={{ color: '#A3BED9', marginRight: '8px' }}
                                                />
                                                Promised time –
                                                <strong>
                                                    {handleDateTimeFormat(
                                                        order?.order_promised_time
                                                    )}
                                                </strong>
                                            </p>
                                        </div>
                                    </div> */}
                                    <div className="">
                                        <div className="left-info ">
                                            <p className="flex mb-2">
                                                <img src={locationImg} />{' '}
                                                <strong
                                                    style={{
                                                        fontWeight: '600',
                                                        fontSize: '16px',
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    {order?.order_location?.location_name}
                                                </strong>
                                            </p>
                                            <p className="flex mb-2">
                                                <img src={deliverImg} />{' '}
                                                <strong
                                                    style={{ fontWeight: '400', marginLeft: '5px' }}
                                                >
                                                    {order?.order_type?.subcategory}
                                                </strong>
                                            </p>
                                        </div>
                                        <div className="right-info mb-2">
                                            <p className="flex">
                                                <WatchLaterOutlined
                                                    style={{ color: '#A3BED9', marginRight: '5px' }}
                                                />
                                                Promised time –
                                                <strong
                                                    style={{
                                                        fontWeight: '500',
                                                        fontSize: '16px',
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    {handleDateTimeFormat(
                                                        order?.order_promised_time
                                                    )}
                                                </strong>
                                            </p>
                                        </div>
                                    </div>

                                    <Accordion
                                        style={{
                                            maxWidth: '100%',
                                            boxShadow: 'none',
                                            borderBottom: '1px solid #c8d4df',
                                            padding: '10px 0',
                                        }}
                                        expanded={expanded === 'panel1'}
                                        onChange={handleChange('panel1')}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                            style={{ width: '100%', padding: '0' }}
                                        >
                                            <Typography>
                                                <p
                                                    className="box-cookie-tx"
                                                    style={{ display: 'block', width: '100%' }}
                                                >
                                                    <span className="flex align-items-center">
                                                        <PersonOutlineOutlined className="pColor" />
                                                        <strong>
                                                            {order?.user?.first_name ??
                                                                order?.guest[0]
                                                                    ?.guest_first_name}{' '}
                                                            {order?.user?.last_name ??
                                                                order?.guest[0]?.guest_last_name}
                                                        </strong>
                                                    </span>
                                                </p>
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                padding: '8px 0',
                                                borderTop: '1px solid #c8d4df',
                                            }}
                                        >
                                            <Typography>
                                                <div className="jacob-info">
                                                    <ul className="corporation-list">
                                                        <li>
                                                            <strong>
                                                                <svg
                                                                    width="20"
                                                                    height="16"
                                                                    viewBox="0 0 20 16"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M3.33203 3.83333C3.33203 4.4926 3.52753 5.13707 3.8938 5.68523C4.26007 6.2334 4.78067 6.66064 5.38975 6.91293C5.99884 7.16522 6.66906 7.23124 7.31567 7.10262C7.96227 6.974 8.55621 6.65653 9.02239 6.19036C9.48856 5.72418 9.80603 5.13024 9.93465 4.48363C10.0633 3.83703 9.99726 3.16681 9.74496 2.55772C9.49267 1.94863 9.06543 1.42804 8.51727 1.06177C7.9691 0.695497 7.32464 0.5 6.66536 0.5C5.78131 0.5 4.93346 0.851189 4.30834 1.47631C3.68322 2.10143 3.33203 2.94928 3.33203 3.83333ZM8.33203 3.83333C8.33203 4.16297 8.23428 4.4852 8.05115 4.75928C7.86801 5.03337 7.60771 5.24699 7.30317 5.37313C6.99863 5.49928 6.66352 5.53228 6.34021 5.46798C6.01691 5.40367 5.71994 5.24493 5.48685 5.01184C5.25377 4.77876 5.09503 4.48179 5.03072 4.15848C4.96641 3.83518 4.99942 3.50007 5.12557 3.19553C5.25171 2.89098 5.46533 2.63069 5.73941 2.44755C6.0135 2.26442 6.33573 2.16667 6.66536 2.16667C7.10739 2.16667 7.53132 2.34226 7.84388 2.65482C8.15644 2.96738 8.33203 3.39131 8.33203 3.83333ZM1.66536 15.5H11.6654C11.8864 15.5 12.0983 15.4122 12.2546 15.2559C12.4109 15.0996 12.4987 14.8877 12.4987 14.6667V12.1667C12.4987 11.2826 12.1475 10.4348 11.5224 9.80964C10.8973 9.18452 10.0494 8.83333 9.16537 8.83333H4.16536C3.28131 8.83333 2.43346 9.18452 1.80834 9.80964C1.18322 10.4348 0.832031 11.2826 0.832031 12.1667V14.6667C0.832031 14.8877 0.919829 15.0996 1.07611 15.2559C1.23239 15.4122 1.44435 15.5 1.66536 15.5ZM2.4987 12.1667C2.4987 11.7246 2.67429 11.3007 2.98685 10.9882C3.29941 10.6756 3.72334 10.5 4.16536 10.5H9.16537C9.60739 10.5 10.0313 10.6756 10.3439 10.9882C10.6564 11.3007 10.832 11.7246 10.832 12.1667V13.8333H2.4987V12.1667ZM19.1654 1.33333C19.1654 1.55435 19.0776 1.76631 18.9213 1.92259C18.765 2.07887 18.553 2.16667 18.332 2.16667H13.332C13.111 2.16667 12.8991 2.07887 12.7428 1.92259C12.5865 1.76631 12.4987 1.55435 12.4987 1.33333C12.4987 1.11232 12.5865 0.900358 12.7428 0.744078C12.8991 0.587797 13.111 0.5 13.332 0.5H18.332C18.553 0.5 18.765 0.587797 18.9213 0.744078C19.0776 0.900358 19.1654 1.11232 19.1654 1.33333ZM19.1654 4.66667C19.1654 4.88768 19.0776 5.09964 18.9213 5.25592C18.765 5.4122 18.553 5.5 18.332 5.5H13.332C13.111 5.5 12.8991 5.4122 12.7428 5.25592C12.5865 5.09964 12.4987 4.88768 12.4987 4.66667C12.4987 4.44565 12.5865 4.23369 12.7428 4.07741C12.8991 3.92113 13.111 3.83333 13.332 3.83333H18.332C18.553 3.83333 18.765 3.92113 18.9213 4.07741C19.0776 4.23369 19.1654 4.44565 19.1654 4.66667ZM19.1654 8C19.1654 8.22101 19.0776 8.43297 18.9213 8.58926C18.765 8.74554 18.553 8.83333 18.332 8.83333H13.332C13.111 8.83333 12.8991 8.74554 12.7428 8.58926C12.5865 8.43297 12.4987 8.22101 12.4987 8C12.4987 7.77899 12.5865 7.56702 12.7428 7.41074C12.8991 7.25446 13.111 7.16667 13.332 7.16667H18.332C18.553 7.16667 18.765 7.25446 18.9213 7.41074C19.0776 7.56702 19.1654 7.77899 19.1654 8Z"
                                                                        fill="#A3BED9"
                                                                    />
                                                                </svg>
                                                                Information
                                                            </strong>
                                                        </li>
                                                        <li>
                                                            <strong>Birthday: </strong>
                                                            <span>
                                                                {handleDateFormat(
                                                                    user?.user_birthday
                                                                )}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <strong>Email: </strong>
                                                            <span> {user?.user_email}</span>
                                                        </li>
                                                        <li>
                                                            <strong>Company: </strong>
                                                            <span> {user?.user_company}</span>
                                                        </li>
                                                        <li>
                                                            <strong>Phone: </strong>
                                                            <span> {user?.user_phone}</span>
                                                        </li>
                                                        <li>
                                                            <strong>Created: </strong>
                                                            <span>
                                                                {handleDateFormat(
                                                                    user?.user_creation_date
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    {orderData.order_type == 'Delivery' ? (
                                                        <ul className="corporation-list">
                                                            <li>
                                                                <strong>
                                                                    <img
                                                                        src={deliverImg}
                                                                        alt="deliverImg"
                                                                    />
                                                                    Delivery Address :
                                                                </strong>
                                                                <span className="mt-2">
                                                                    {' '}
                                                                    {
                                                                        order?.delivery[0]
                                                                            ?.order_delivery_address
                                                                    }
                                                                </span>
                                                            </li>
                                                            {/* <li>
                                                                <strong>Street: </strong>{' '}
                                                                <span></span>
                                                            </li>
                                                            <li>
                                                                <strong>Apt Suite: </strong>{' '}
                                                                <span></span>
                                                            </li>
                                                            <li>
                                                                <strong>City: </strong>{' '}
                                                                <span></span>
                                                            </li>
                                                            <li>
                                                                <strong>State: </strong>{' '}
                                                                <span></span>
                                                            </li> */}
                                                        </ul>
                                                    ) : null}
                                                </div>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    {orderData.order_type == 'Delivery' ? (
                                        <div
                                            className="assign-drive"
                                            style={{
                                                paddingTop: '15px',
                                                paddingBottom: '20px',
                                                borderBottom: '1px solid #dfdfdf',
                                            }}
                                        >
                                            <div>
                                                <strong>Assigned Driver:</strong>
                                                <span>
                                                    <AccountBoxOutlined className="pColor" />
                                                </span>
                                            </div>
                                            <div>
                                                <strong>Order placed:</strong>
                                                <span>
                                                    {handleDateTimeFormat(
                                                        order?.order_creation_date
                                                    )}
                                                </span>
                                            </div>
                                            <div>
                                                <strong>Location Address:</strong>
                                                <span>
                                                    {order?.order_location?.location_address_1}{' '}
                                                    {order?.order_location?.location_address_2},{' '}
                                                    {order?.order_location?.location_state}{' '}
                                                    {order?.order_location?.location_zip}
                                                </span>
                                            </div>
                                            <div>
                                                <strong>Delivery Address:</strong>
                                                <span>
                                                    {order?.delivery[0]?.order_delivery_address}
                                                </span>
                                            </div>
                                        </div>
                                    ) : null}
                                    <Accordion
                                        expanded={expanded === 'panel2'}
                                        onChange={handleChange('panel2')}
                                        style={{
                                            maxWidth: '100%',
                                            boxShadow: 'none',
                                            borderBottom: '1px solid #c8d4df',
                                            padding: '10px 0',
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2bh-content"
                                            id="panel2bh-header"
                                            style={{ width: '100%', padding: '0' }}
                                        >
                                            <p className="box-cookie-tx">
                                                <span>
                                                    <strong>Loyalty Points:</strong>
                                                    {/*<span className="dark-tx">
                                                                #3347895
                                                            </span>*/}
                                                </span>{' '}
                                                <span
                                                    className="add-tx"
                                                    style={{ color: '#111111' }}
                                                >
                                                    {loyaltyData?.points} points
                                                </span>
                                            </p>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                padding: '8px 0',
                                                borderTop: '1px solid #c8d4df',
                                            }}
                                        >
                                            <Typography>
                                                <ul className="order-listing">
                                                    {loyaltyData?.data?.map(
                                                        (data: any, index: any) => (
                                                            <li key={index}>
                                                                <p className="cookie-flx">
                                                                    <span className="text-left">
                                                                        Order ID: #{data.order?.id}
                                                                    </span>
                                                                    <div className="flex">
                                                                        <p className="text-left">
                                                                            {moment(
                                                                                data.date_created
                                                                            ).format(
                                                                                'MM/DD/YYYY'
                                                                            )}{' '}
                                                                            / &nbsp;
                                                                        </p>

                                                                        <span>
                                                                            {data.applied_points}{' '}
                                                                            points
                                                                        </span>
                                                                    </div>
                                                                </p>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion
                                        expanded={expanded === 'panel3'}
                                        onChange={handleChange('panel3')}
                                        style={{
                                            maxWidth: '100%',
                                            boxShadow: 'none',
                                            borderBottom: '1px solid #c8d4df',
                                            padding: '10px 0',
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel3bh-content"
                                            id="panel3bh-header"
                                            style={{ width: '100%', padding: '0' }}
                                        >
                                            <Typography>
                                                <p
                                                    className="box-cookie-tx"
                                                    style={{ width: '100%' }}
                                                >
                                                    <span>
                                                        <strong>Status Log</strong>
                                                    </span>
                                                </p>
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            style={{
                                                padding: '8px 0',
                                                borderTop: '1px solid #c8d4df',
                                            }}
                                        >
                                            <Typography>
                                                <ul className="order-listing order-listdate">
                                                    {order?.status?.map((data: any) => {
                                                        return (
                                                            <li key={order?.status?.id}>
                                                                <p className="cookie-flx">
                                                                    <div className="complete-order">
                                                                        <span
                                                                            className={`light-bg orders order_status-${data?.order_status}`}
                                                                        >
                                                                            {data.order_status}
                                                                        </span>
                                                                    </div>
                                                                    <span>
                                                                        {data?.user?.first_name}{' '}
                                                                        {data?.user?.last_name}
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            textAlign: 'right',
                                                                        }}
                                                                    >
                                                                        {moment(
                                                                            data.timestamp
                                                                        ).format(
                                                                            'MM/DD/YYYY, HH:mm A'
                                                                        )}
                                                                    </span>
                                                                </p>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                                <div className="col-12 col-md-4 order-col-rgt">
                                    <div className="info-header location-edit">
                                        <div className="left-info">
                                            <img src={orderImg} alt="orderImg" />{' '}
                                            <strong>Order</strong>
                                        </div>
                                    </div>
                                    <div
                                        className="new-products-list"
                                        style={{ borderBottom: 'none', paddingTop: '20px' }}
                                    >
                                        {order?.cart_group?.cart?.map((item: any) => {
                                            return (
                                                <div key={item.id} className="pr-list">
                                                    <div className="row">
                                                        <div className="col-12 col-md-8">
                                                            <div className="new-ordr d-flex align-items-center">
                                                                <div
                                                                    className="ordr-icn"
                                                                    style={{
                                                                        border: '1px solid #C8D4DF',
                                                                        borderRadius: '6px',
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            item.menu?.product
                                                                                ?.product_image
                                                                        }
                                                                        width="60px"
                                                                        onError={handleOnError}
                                                                        height="60px"
                                                                        alt="item"
                                                                    />
                                                                </div>
                                                                <div
                                                                    className="order-details"
                                                                    style={{ fontSize: '14px' }}
                                                                >
                                                                    <p className="mb-0">
                                                                        <strong>
                                                                            {
                                                                                item.menu?.product
                                                                                    ?.product_name
                                                                            }
                                                                        </strong>
                                                                    </p>
                                                                    <p className="mb-0"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-md-4">
                                                            <div className="order-quantity d-flex justify-content-between align-items-center h-100">
                                                                <p className="mb-0">
                                                                    {item.menu_item_quantity} x{' '}
                                                                    <strong>
                                                                        $
                                                                        {getDollarPrice(
                                                                            item.menu_item_price
                                                                        )}
                                                                    </strong>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {item.menu_item_modifiers &&
                                                        item.menu_item_modifiers.map(
                                                            (modifier: any) => (
                                                                <p
                                                                    className="instructions f-14 pt-2"
                                                                    key={modifier.id}
                                                                >
                                                                    <strong>
                                                                        {modifier.modification_text}
                                                                        :
                                                                    </strong>
                                                                    {modifier?.options?.map(
                                                                        (option: any) => (
                                                                            <div key={option.id}>
                                                                                {option.option_name}
                                                                                <span className="pColor">
                                                                                    {option.option_price
                                                                                        ? '($' +
                                                                                          getDollarPrice(
                                                                                              option.option_price
                                                                                          ) +
                                                                                          ')'
                                                                                        : ''}
                                                                                </span>
                                                                                ,
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </p>
                                                            )
                                                        )}
                                                    {item.menu_item_instructions ? (
                                                        <p className="instructions f-14 pt-2">
                                                            <InfoOutlined className="pColor" />{' '}
                                                            Special instructions:{' '}
                                                            <strong>
                                                                {item.menu_item_instructions}
                                                            </strong>
                                                        </p>
                                                    ) : // <p className="instructions f-14 pt-2">
                                                    //     {
                                                    //         item.menu?.product
                                                    //             ?.product_description
                                                    //     }
                                                    // </p>
                                                    null}
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <ul
                                        className="instruction-listing"
                                        style={{ borderTop: '0', paddingTop: '0' }}
                                    >
                                        {/*<li className="flex justify-between">
                                            <span>
                                                <EmojiEventsOutlined
                                                    className="pColor"
                                                    style={{ marginRight: '8px' }}
                                                />
                                                Points
                                            </span>
                                            <span className="dark-tx">{order?.order_total}</span>
                                </li>*/}
                                        {order?.order_subtotal ? (
                                            <li className="flex justify-between">
                                                <span>Subtotal</span>
                                                <span className="dark-tx">
                                                    ${getDollarPrice(order?.order_subtotal)}
                                                </span>
                                            </li>
                                        ) : null}
                                        {order?.order_delivery_fee ? (
                                            <li className="flex justify-between">
                                                <span>Delivery</span>
                                                <span className="dark-tx">
                                                    ${getDollarPrice(order?.order_delivery_fee)}
                                                </span>
                                            </li>
                                        ) : null}
                                        {order?.order_tax ? (
                                            <li className="flex justify-between">
                                                <span> Tax</span>
                                                <span>${getDollarPrice(order?.order_tax)}</span>
                                            </li>
                                        ) : null}
                                        {order?.order_tip ? (
                                            <li className="flex justify-between">
                                                <span>Tip</span>
                                                <span className="dark-tx">
                                                    ${getDollarPrice(order?.order_tip)}
                                                </span>
                                            </li>
                                        ) : null}
                                        {order?.order_coupon_code_discount ? (
                                            <li className="flex justify-between">
                                                <span>Promo</span>
                                                <span className="dark-tx">
                                                    - $
                                                    {getDollarPrice(
                                                        order?.order_coupon_code_discount
                                                    )}
                                                </span>
                                            </li>
                                        ) : null}
                                        {order?.order_gift_card_amount ? (
                                            <li className="flex justify-between">
                                                <span>Gift Card</span>
                                                <span className="dark-tx">
                                                    - $
                                                    {getDollarPrice(order?.order_gift_card_amount)}
                                                </span>
                                            </li>
                                        ) : null}
                                        {order?.credit_amount ? (
                                            <li className="flex justify-between">
                                                <span>Credit</span>
                                                <span className="dark-tx">
                                                    - ${getDollarPrice(order?.credit_amount)}
                                                </span>
                                            </li>
                                        ) : null}
                                        <li className="flex justify-between">
                                            <strong style={{ fontSize: '16px', fontWeight: '500' }}>
                                                Total
                                            </strong>
                                            <span>
                                                <strong
                                                    style={{
                                                        color: '#111111',
                                                        fontSize: '16px',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    ${getDollarPrice(order?.order_total)}
                                                </strong>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        ) : (
                            <>
                                <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                <Skeleton variant="text" height={40} />
                                <Skeleton variant="rectangular" height={60} />
                                <Skeleton variant="text" height={60} />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditOrder;
